import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const REFERRAL_STORAGE_KEY = 'fonorex_referral_code';

/**
 * Hook to capture referral code from URL parameter (?ref=CODE)
 * and store it in localStorage for use during registration
 */
export function useReferralCodeCapture(): void {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const refCode = searchParams.get('ref');
    if (refCode) {
      localStorage.setItem(REFERRAL_STORAGE_KEY, refCode.toUpperCase());
    }
  }, [searchParams]);
}

/**
 * Get the stored referral code from localStorage
 */
export function getReferralCode(): string | null {
  return localStorage.getItem(REFERRAL_STORAGE_KEY);
}

/**
 * Clear the stored referral code (call after successful registration)
 */
export function clearReferralCode(): void {
  localStorage.removeItem(REFERRAL_STORAGE_KEY);
}

/**
 * Set referral code manually
 */
export function setReferralCode(code: string): void {
  localStorage.setItem(REFERRAL_STORAGE_KEY, code.toUpperCase());
}

const VISITOR_ID_KEY = 'fonorex_visitor_id';

/**
 * Get the visitor ID from localStorage (set by landing page)
 */
export function getVisitorId(): string | null {
  return localStorage.getItem(VISITOR_ID_KEY);
}
